import React from 'react';
import { getHashedColor } from '@/utils/colorHash';
import styles from './InitialsBadge.module.scss';

export const initialsBadgeShapes = {
  circle: 'circle',
  square: 'square',
};

export const InitialsBadgeComponent = ({
  label,
  twoLetter = false,
  shape = initialsBadgeShapes.circle,
}) => {
  const name = (label || '?').trim();
  const words = name.split(/\s+/).filter(Boolean);
  const initials =
    twoLetter && words.length > 1
      ? `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`
      : name.charAt(0) || '?';
  const color = getHashedColor(name);

  return (
    <span
      className={styles.initialsBadge}
      data-color={color}
      data-shape={shape}
    >
      {initials.toUpperCase()}
    </span>
  );
};

InitialsBadgeComponent.displayName = 'InitialsBadge';
